























import {Component, Prop, VModel, Vue} from "vue-property-decorator";
import {v4 as uuidv4, v4} from "uuid";

@Component
export default class BTPortalCollapse extends Vue {
	@Prop({default: function () {return uuidv4()}})
	private id!: string | null;

	@Prop({default: "Title"})
	private label!: string | null;

	@VModel( {type: Boolean})
	private open!: boolean | undefined

	private internalOpen = false;

	public created() {
		if (this.open) {
			this.internalOpen = this.open
		}
		this.$validator.remove("rotation")
	}


	private toggle() {
		this.internalOpen = !this.internalOpen
		this.$emit("input", !this.internalOpen)
	}
}

